type AnalyticsEvent = { [key: string]: string } & { event: string };

class Analytics {
  private debugMode = true;

  constructor() {
    //@ts-expect-error
    if (!window.dataLayer) console.warn("Analytics not initialised");
    else console.log("📊 Analytics are on");
  }

  pushEvent = (ev: AnalyticsEvent) => {
    this.debugMode && console.log("[ANALYTICS EVENT PUSH]", ev);
    //@ts-expect-error
    window.dataLayer && window.dataLayer.push(ev);
  };

  allowCameraAccess = (granted: boolean) =>
    this.pushEvent({
      event: "allow_camera",
      parameter: "permission_status",
      parameterValue: granted ? "allowed" : "denied",
    });
}

export default new Analytics();
